import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Gabriel from "../../../assets/shortlist_22/gabriel.jpg";
import Idris from "../../../assets/shortlist_22/idris.jpg";
import Solomon from "../../../assets/shortlist_22/solomon.jpg";
import Tunde from "../../../assets/shortlist_22/tunde.jpg";

const communityNominees = [
  {
    name: "Gabriel Obinna Andrew",
    title: "NYSC Community Development Advocate",
    imgpath: Gabriel,
    story:
      "Obinna Andrew Gabriel is a leadership advocate and a Mass Communication graduate of the University of Benin, Ekehuan Campus, who facilitated the construction of a road and the institution of an improved waste management model in Aiyegbami community in Kwara State where he was serving as a member of the National Youth Service Corps (NYSC). ",
  },
  {
    name: "Idris Bilyaminu Ndasadu",
    title: "YAPD4Africa",
    imgpath: Idris,
    story:
      "Youth Awareness for Peace and Development (YAPD4Africa) is a nonprofit organization which focus on the grassroot communities to improve education, health, well-being, WASH (Water and Sanitation Hygiene) facilities and social inclusion of the vulnerable children, women and young people.",
  },
  {
    name: "Solomon O. Ayodele",
    title: "Boys Quarters Africa",
    imgpath: Solomon,
    story:
      "Boys Quarters Africa is a volunteer-driven developmental organization and a Boy-child transformation movement missioned with the core objective of educating, empowering and advocating for the BoyChild.",
  },
  {
    name: "Tunde Onakoya",
    title: "Chess in Slums",
    imgpath: Tunde,
    story:
      "Babatunde Onakoya founded Chess in Slums Africa (CISA) in 2018. This nonprofit organization’s goal is to teach underprivileged children how to play chess to keep them off the street. The founder uses the metaphor that just like the pawn can become a queen, underprivileged children can also become kings and queens.",
  },
];

const CommunityNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Award for Community Service (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {communityNominees.map((nominate, index) => {
          const { name, title, imgpath, story } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paragraph
                      variant="body2"
                      fontWeight={400}
                      color="#4f4f4f"
                      textAlign={"center"}
                    >
                      {story}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default CommunityNominees;
